import { useSelector } from "react-redux";
import "./style.scss";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { RootState } from "@/src/store";
import { useEffect } from "react";

const Preloyder = () => {
  const { isPreloyder } = useSelector((state: RootState) => state.Preloyder);

  useEffect(() => {
    const body = document.body;
    if (isPreloyder) {
      body.classList.add("hidden");
    } else {
      body.classList.remove("hidden");
    }
    return () => {
      body.classList.remove("hidden");
    };
  }, [isPreloyder]);

  return (
    <div className="preloyder">
      <div className="preloyder-content">
        <DotLottieReact src="https://lottie.host/3e332524-2b37-4ec5-9c5b-995d85d5aecf/HS52V89q0z.lottie" loop autoplay />
      </div>
    </div>
  );
};

export default Preloyder;
